import "./App.css";
import myLogo from "./images/addiction_logo.png";

function App() {
  return (
    <div className="app">
      <div className="menu-container">
        <img src={myLogo} alt="Addiction Logo" className="menu-logo" />

        <div className="menu-buttons">
          <a
            className="menu-button"
            href="/addiction_zgharta.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Zgharta Menu
          </a>

          <a
            className="menu-button"
            href="/addiction_bnachii_lake.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Bnachii Lake Menu
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
